module.exports = __webpack_public_path__ + "static/34-e4d5514180e5e2b420e9bf91c6bda45e.png";